<template>
  <table class="table is-bordered w-100">
    <tbody>
      <tr v-for="(row, i) in years" :key="i">
        <td
          v-for="(year, j) in row"
          :key="j"
          class="is-pointer"
          :class="{'is-selected': isSelected(year)}"
          :data-year="year"
          @click="selectYear(year)"
        >
          <div>{{year}}</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { chunk } from "../utils/base";

export default {
  name: "datepicker-list-year",
  props: {
    decade: Number,
    value: {
      type: Number,
    },
  },
  data() {
    return {
      selectedYear: undefined,
    };
  },
  mounted() {
    this.selectedYear = this.value;
  },
  computed: {
    years() {
      let firstYear = this.decade;
      let years = [];
      for (let i = 0; i < 10; i++) {
        years.push(firstYear + i);
      }
      return chunk(years, 2);
    },
  },
  methods: {
    isSelected(year) {
      return this.selectedYear === year;
    },
    selectYear(year) {
      this.selectedYear = year;
      let returnYear = parseInt(year, 10);
      this.$emit("input", returnYear);
      this.$emit("change", returnYear);
    },
  },
};
</script>